/*
 * workdate.js — one place that decides what "today" and "tomorrow" mean.
 *
 * Build 001 introduces a work date on Project Assignment. Every surface that
 * asks "what is Test Worker One assigned to today?" must agree on the answer, so the
 * stamp is computed here and nowhere else.
 *
 * Local calendar date, not UTC. A crew checking in at 6:45 AM in New Jersey is
 * working "today" by their own clock; a UTC stamp would roll the day over in
 * the middle of the night and silently move assignments.
 */

/** @returns {string} local calendar date as YYYY-MM-DD */
export function isoDate(d = new Date()) {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

export function todayISO() {
  return isoDate(new Date())
}

export function addDaysISO(isoOrDate, days) {
  const base = typeof isoOrDate === 'string' ? fromISO(isoOrDate) : new Date(isoOrDate)
  base.setDate(base.getDate() + days)
  return isoDate(base)
}

export function tomorrowISO() {
  return addDaysISO(todayISO(), 1)
}

/** Parse YYYY-MM-DD as a LOCAL date (new Date('2026-09-15') would be UTC). */
export function fromISO(iso) {
  const [y, m, d] = String(iso).split('-').map(Number)
  return new Date(y, (m || 1) - 1, d || 1)
}

/** "Mon, Sep 15" — for owner-facing date display. */
export function formatHuman(iso) {
  try {
    return fromISO(iso).toLocaleDateString([], {
      weekday: 'short', month: 'short', day: 'numeric',
    })
  } catch {
    return iso
  }
}

/** "Today" / "Tomorrow" / "Mon, Sep 15" — the label the owner actually reads. */
export function formatRelative(iso) {
  if (iso === todayISO()) return 'Today'
  if (iso === tomorrowISO()) return 'Tomorrow'
  return formatHuman(iso)
}
